import React from "react";
import { Alert } from "react-bootstrap";

const GlobalAlert = ({ show, message, variant = "success", onClose }) => {
  if (!show) return null;
  return (
    <Alert
      variant={variant}
      className="position-fixed top-0 start-50 translate-middle-x w-50 text-center fade show d-print-none"
      style={{ zIndex: 2000, transition: "transform 0.5s, opacity 0.5s" }}
      dismissible
      onClose={onClose}
    >
      {message}
    </Alert>
  );
};

export default GlobalAlert;